<script setup lang="ts">
import type { Map } from "mapbox-gl";

// Enveloppe web d'AppMap : injecte le consentement Mapbox (cookie-consent web) et le
// placeholder affiché tant qu'il n'est pas donné. AppMap (partagé) reste agnostique du
// consentement ; mobile l'utilise directement (toujours autorisé en natif).
defineOptions({ inheritAttrs: false });

const { mapbox: mapboxAllowed } = useCookieConsent();

const inner = useTemplateRef<{ mapboxMap: Map | undefined; isFullscreen: boolean }>("inner");

defineExpose({
  get mapboxMap() {
    return inner.value?.mapboxMap;
  },
  get isFullscreen() {
    return inner.value?.isFullscreen;
  },
});
</script>

<template>
  <AppMap ref="inner" :mapbox-allowed="mapboxAllowed" v-bind="$attrs">
    <template #disabled>
      <WebCookieConsentMapPlaceholder class="size-full rounded-(--ui-radius)" />
    </template>
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </AppMap>
</template>
